"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdCampaignPeriodGenerator = void 0;
var enums_1 = require("../../../../enums");
var utils_1 = require("../utils");
var types_1 = require("../../types");
var DateTimeCheckService_1 = __importDefault(require("../../../DateTimeCheckService"));
var base_1 = require("../base");
var AdCampaignPeriodGenerator = (function (_super) {
    __extends(AdCampaignPeriodGenerator, _super);
    function AdCampaignPeriodGenerator(adCampaign, timezone, logger, tracing) {
        var _this = _super.call(this, adCampaign, timezone) || this;
        _this.lastTime = null;
        _this.startPeriodTime = null;
        _this.promos = adCampaign.promos;
        _this.promoIterator = new utils_1.PromoIterator(_this.promos);
        _this.intervalDelta = _this.initializeInterval();
        _this.logger = logger;
        _this.tracing = tracing;
        return _this;
    }
    AdCampaignPeriodGenerator.prototype.initializeInterval = function () {
        var period = this.adcampaign.period;
        return this.promos.length ? Math.round((period * 60) / this.promos.length) : 60;
    };
    AdCampaignPeriodGenerator.prototype.isInInvalidState = function () {
        var maxPromoDuration = Math.max.apply(Math, __spreadArray([], __read(this.promos.map(function (p) { return p.duration; })), false));
        return !this.promos.length || this.intervalDelta < maxPromoDuration / 1000;
    };
    AdCampaignPeriodGenerator.prototype.getRotation = function (_a) {
        var lastRotations = _a.lastRotations, nextTime = _a.nextTime, rotations = _a.rotations;
        if (!rotations.length) {
            return new types_1.GetRotationSkip();
        }
        if (this.isInInvalidState()) {
            return new types_1.GetRotationSkip();
        }
        if (!this.startPeriodTime) {
            this.startPeriodTime = nextTime.clone();
        }
        if (!this.lastTime) {
            this.lastTime = this.startPeriodTime.clone();
        }
        var nextPeriod = this.startPeriodTime.add(this.adcampaign.period, "minutes");
        if (nextPeriod.isBefore(nextTime))
            nextPeriod = nextTime;
        if (this.lastTime.isSameOrAfter(nextPeriod)) {
            this.promoIterator.resetIndex();
            this.startPeriodTime = this.startPeriodTime.add(this.adcampaign.period, "minutes");
            this.lastTime = this.startPeriodTime;
        }
        if (this.lastTime.isSameOrBefore(nextTime)) {
            var result = this.convertPromoToRotation({
                mediafileData: this.promoIterator.getPromo(),
                insertTime: nextTime,
                campaignType: enums_1.EAdCampaignType.PERIOD,
                adcompanyId: this.adcampaign.id,
            });
            this.lastTime = this.lastTime.clone().add(this.intervalDelta, "seconds");
            if (DateTimeCheckService_1.default.checkNextTimeForObject(this.adcampaign, result.nextTime)) {
                return new types_1.GetRotationResult(result.nextTime, result.rotation);
            }
        }
        return new types_1.GetRotationSkip();
    };
    return AdCampaignPeriodGenerator;
}(base_1.AdGeneratorBaseAbstract));
exports.AdCampaignPeriodGenerator = AdCampaignPeriodGenerator;
//# sourceMappingURL=index.js.map